module.exports = __webpack_public_path__ + "img/a2.6dd3b37d.png";